"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.Text = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(creator_ui_1.Text, { as: "div", width: "100%" }, children));
};
exports.Text.displayName = "Text";
exports.Text.editableFields = [];
